import { useTranslation } from 'react-i18next';

export const SearchInputText = ({ onSearch }) => {
	const { t } = useTranslation();
	return <input className="form-control form-control-sm flex-grow-1 mr-2" style={{ width: 'inherit' }} type="text" placeholder={t('g.search')} onChange={(e) => onSearch(e.target?.value ?? '')} />;
};
